import React, { useState } from "react";
import { toast } from "sonner";
import { Loader2, KeyRound } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

// Second-step login: verify a 6-digit TOTP code or a recovery code.
export function TwoFactorChallenge({ challengeToken, onSuccess }) {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [recovery, setRecovery] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/2fa/login", { challenge_token: challengeToken, code: code.trim() });
      onSuccess(data);
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || "Invalid code.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="twofa-challenge">
      <div className="w-12 h-12 grid place-items-center border border-brand/40 text-brand mb-4"><KeyRound className="w-6 h-6" /></div>
      <h1 className="font-serif text-3xl font-semibold">Two-factor verification</h1>
      <p className="text-muted-foreground text-sm mt-2">
        {recovery ? "Enter one of your saved recovery codes." : "Enter the 6-digit code from your authenticator app."}
      </p>
      <form onSubmit={submit} className="mt-8 space-y-4">
        <Input autoFocus inputMode={recovery ? "text" : "numeric"} autoComplete="one-time-code"
          value={code} onChange={(e) => setCode(recovery ? e.target.value.toUpperCase() : e.target.value.replace(/\D/g, "").slice(0, 6))}
          className="rounded-none text-center text-2xl tracking-[0.3em] font-mono h-14"
          placeholder={recovery ? "RECOVERY" : "000000"} data-testid="twofa-code" />
        <Button type="submit" className="w-full rounded-none" disabled={loading || code.length < 6} data-testid="twofa-submit">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Verify & sign in"}
        </Button>
      </form>
      <button onClick={() => { setRecovery((v) => !v); setCode(""); }} className="text-sm text-brand hover:underline mt-5" data-testid="twofa-toggle-recovery">
        {recovery ? "Use authenticator code instead" : "Use a recovery code"}
      </button>
    </div>
  );
}
